module.exports = __webpack_public_path__ + "static/img/logo_top.fcd8eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_top.png
// module id = b0QB
// module chunks = 3